import type { DataState } from '@/stores/dataStore';
import { guildVoiceCount } from './railVoice';

/**
 * Per-guild totals for the server rail, meant for `useShallow`: the rail
 * re-renders when a guild's badge number changes, not on every unread bump
 * or voice move anywhere (it subscribed to the whole maps before).
 */

export function selectUnreadByGuild(s: DataState): Record<string, number> {
  const out: Record<string, number> = {};
  for (const [guildId, guild] of Object.entries(s.guilds)) {
    let total = 0;
    for (const channel of guild.channels) total += s.unreadByChannel[channel.id] ?? 0;
    out[guildId] = total;
  }
  return out;
}

export function selectVoiceByGuild(s: DataState): Record<string, number> {
  const out: Record<string, number> = {};
  for (const [guildId, guild] of Object.entries(s.guilds)) {
    out[guildId] = guildVoiceCount(guild.channels, s.voiceByChannel);
  }
  return out;
}
